import React from 'react'

type LabelProps = {
  title: string
  subtitle?: string
}

export const BogoFeatureLabel = ({ title, subtitle }: LabelProps) => (
  <div
    role='cell'
    className='col-12 d-flex justify-content-center align-items-center'
  >
    <div className='d-none d-lg-block'>
      <Label title={title} subtitle={subtitle} />
    </div>
    <div className='d-block d-lg-none'>
      <Label title={title} subtitle={subtitle} className='mc-text-large' />
    </div>
  </div>
)

const Label = ({
  title,
  subtitle,
  className = '',
}: LabelProps & { className?: string }) => (
  <div className={`mc-pb-8 mc-text--center ${className}`}>
    <span className='mc-text--1-line mc-text--bold'>{title}</span>
    <span className='mc-opacity--hinted'>{subtitle}</span>
  </div>
)
